import { AssetType, InstrumentSummary } from "../instruments/types";

export const OTHER_EXCHANGE = "OTHER";

export interface RequestableExchange {
  code: string;
  name: string;
}

export interface TickerRequestPayload {
  symbol: string;
  exchange: string;
  otherExchangeName?: string;
  note?: string;
}

export interface SubmittedTickerRequest {
  symbol: string;
  exchange: string;
  otherExchangeName: string | null;
}

export interface PendingTickerRequestNote {
  note: string;
  requestedAt: string;
}

export interface PendingTickerRequest {
  id: number;
  symbol: string;
  exchange: string;
  otherExchangeName: string | null;
  exchangeLabel: string;
  requesterCount: number;
  notes: PendingTickerRequestNote[];
  createdAt: string;
}

export type PairAssetType = Extract<AssetType, "CRYPTO" | "FOREX">;

export type TickerRequestApproval =
  | { method: "EXISTING"; instrumentId: number }
  | { method: "LISTED"; symbol: string; exchange: string; yahooSymbol: string }
  | {
      method: "PAIR";
      symbol: string;
      exchange: string;
      assetType: PairAssetType;
      nativeCurrency: string;
      name?: string;
    }
  | {
      method: "MANUAL";
      symbol: string;
      exchange: string;
      assetType: AssetType;
      nativeCurrency: string;
      name?: string;
    };

export interface ApproveTickerRequestPayload {
  requestId: number;
  approval: TickerRequestApproval;
}

export interface ApprovedTickerRequest {
  instrument: InstrumentSummary;
}

export interface RejectTickerRequestPayload {
  requestId: number;
  reason: string;
}
